import { defineMessage } from 'services/localization';

export const messages = {
    previous: defineMessage('previous'),
    actual: defineMessage('actual'),
    paymentMethod: defineMessage('payment_method_1'),
    entityType: defineMessage('entity_type_1'),
    bankCountry: defineMessage('bank_account_country_1'),
    accountCurrency: defineMessage('account_currency_1'),
    bankAccountName: defineMessage('account_name_1'),
    accountNumber: defineMessage('account_number_1'),
    bicSwift: defineMessage('bic_swift_code_1'),
    address: defineMessage('address_1'),
    city: defineMessage('city_1'),
    country: defineMessage('country_1'),
    postalCode: defineMessage('postal_code_1'),
    stateOrProvince: defineMessage('state_province_1'),
    firstName: defineMessage('first_name_1'),
    lastName: defineMessage('last_name_1'),
    companyName: defineMessage('company_name_1'),
    sortCode: defineMessage('sort_code_1'),
    aba: defineMessage('aba_2'),
    bsb: defineMessage('bsb_2'),
    institutionNumber: defineMessage('institution_number_1'),
    incorporationNumber: defineMessage('incorporation_number_1'),
    bankCode: defineMessage('bank_code_1'),
    branchCode: defineMessage('branch_code_1'),
    clabe: defineMessage('clabe_2'),
    cnaps: defineMessage('cnaps_2'),
    iban: defineMessage('iban_1'),
    ifsc: defineMessage('ifsc_code_1'),
    company: defineMessage('company'),
    individual: defineMessage('individual'),
};
